import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { TextDate } from "components/MyControl";
import ApiConection from "api_ref/ApiConection";

export default function AccountFilter({ title, search, handleSetCondition, handleSetSearch }) {
    const api = new ApiConection();

    const [filterDispaly, setFilterDisplay] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState([]);
    const [auditStatus, setAuditStatus] = useState([]);

    const handleQuickSearch = (event) => {
        //console.log(event.target);
        const { name, value } = event.target;

        handleSetSearch('company_name', value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const handleFullSearch = (event) => {
        const { name, value } = event.target;
        handleSetSearch(name, value);
        handleSetSearch('page', 1);
        handleSetSearch('size', search.size);
    }

    const callPaymentStatus = async () => {
        const response = await api.getData('api/master/payment-status');
        if (response.status === true) {
            setPaymentStatus(response.data);
        }
    }

    const callAuditStatus = async () => {
        const response = await api.getData('api/master/audit-status');
        if (response.status === true) {
            setAuditStatus(response.data);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await callPaymentStatus();
            await callAuditStatus();
        }

        fetchData();
    }, [])
    return (
        <div className={Css.Header}>
            <div className="d-flex">
                <h6 className="d-flex align-items-center">{title}</h6>
                <div className="flex-fill">
                    <Form.Group as={Row}>
                        <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                        <Col>
                            <InputGroup>
                                <Form.Control placeholder="บริษัท" name={'company_name'} value={search.company_name}
                                    disabled={filterDispaly}
                                    onChange={(event) => handleQuickSearch(event)} />
                                <Button variant="outline-secondary" onClick={event => setFilterDisplay(!filterDispaly)}>
                                    {
                                        filterDispaly === true &&
                                        <i className="fa-solid fa-arrow-up-short-wide"></i>
                                    }
                                    {
                                        filterDispaly === false &&
                                        <i className="fa-solid fa-arrow-down-short-wide"></i>
                                    }
                                    <span></span>
                                </Button>
                                <Button>
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </Button>
                            </InputGroup>

                        </Col>
                    </Form.Group>
                </div>
            </div>
            {
                filterDispaly === true &&
                <div className="d-flex bg-">
                    <div className="w-100 bg-light p-3">
                        <Row className="mb-2">
                            <Col>
                                <Form.Label>ใบสั่งซื้อ</Form.Label>
                                <Form.Control name={'quontation_number'} value={search.quontation_number} onChange={handleFullSearch} />
                            </Col>
                            <Col>
                                <Form.Label>ชื่อบริษัท</Form.Label>
                                <Form.Control name={'company_name'} value={search.company_name} onChange={handleFullSearch} />
                            </Col>
                            <Col>
                                <Form.Label>แพ็กเกจ</Form.Label>
                                <Form.Control name={'package_master_name'} value={search.package_master_name} onChange={handleFullSearch} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Label>วันที่ครบกำหนด</Form.Label>
                                <InputGroup className="flex-nowrap">
                                    <InputGroup.Text>จาก</InputGroup.Text>
                                    <TextDate name={'due_date_from'} onChange={handleFullSearch} />
                                    <InputGroup.Text>ถึง</InputGroup.Text>
                                    <TextDate name={'due_date_to'} onChange={handleFullSearch} />
                                </InputGroup>
                            </Col>
                            <Col>
                                <Form.Label>วันที่ชำระเงิน</Form.Label>
                                <InputGroup className="flex-nowrap">
                                    <InputGroup.Text>จาก</InputGroup.Text>
                                    <TextDate name={'paid_date_from'} onChange={handleFullSearch} />
                                    <InputGroup.Text>ถึง</InputGroup.Text>
                                    <TextDate name={'paid_date_to'} onChange={handleFullSearch} />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Label>สถานะลูกค้า</Form.Label>
                                <Form.Select name={'payment_status_id'} value={search.payment_status_id} onChange={handleFullSearch} >
                                    <option value={''}>ทั้งหมด</option>
                                    {
                                        paymentStatus?.map((obj, index) => (
                                            <option key={index} value={obj.id}>{obj.name}</option>
                                        ))
                                    }
                                </Form.Select>
                            </Col>
                            <Col>
                                <Form.Label>สถานะเอกสาร</Form.Label>
                                <Form.Select name={'audit_status_id'} value={search.audit_status_id} onChange={handleFullSearch} >
                                    <option value={''}>ทั้งหมด</option>
                                    {
                                        auditStatus?.map((obj, index) => (
                                            <option key={index} value={obj.id}>{obj.name}</option>
                                        ))
                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                    </div>
                </div>
            }
        </div>
    )
}